import React, { createContext, useContext } from "react";
import useNotifications from "../../../useNotifications";

const status = 'all';

export const NotificationsHistoryContext = createContext({
  loading: false,
  _notifications: [],
  _fetch: [],
  total: 0,
});

export const NotificationsHistoryProvider = ({ children }) => {
  const { loading, _notifications, _fetch, total } = useNotifications({ status });
  const value = { loading, _notifications, _fetch, total };

  return (
    <NotificationsHistoryContext.Provider value={value}>
      {children}
    </NotificationsHistoryContext.Provider>
  )
};

export const useNotificationsHistoryContext = () => {
  const value = useContext(NotificationsHistoryContext);
  return value;
}
